export default "__VITE_ASSET__kJDRN4pf__"